////////////////////////////////////////////////////////////
//     							                          //
//  Program: CountryService.js                            //
//  Application: Services                                 //
//  Option: Used for country list                         //
//  Developer: NP 						                  //
//  Date: 2022-01-04                                      //
//                                                        //
////////////////////////////////////////////////////////////

import ApiService from './ApiService'

class CountryService {
    //for google places API
    checkLocation(data) {
        // Delete data which we don't want to send
        delete data.errors;
        delete data.input;

        let endPoint = 'check-location';
        let addditionalHeaderData = {};
        let postData = data;

        let inputData = {
            'endPoint': endPoint,
            'addditionalHeaderData': addditionalHeaderData,
            'postData': postData
        }
        let response = ApiService.postCall(inputData);
        return response;
    }
    
}

export default new CountryService()
